import React from "react";
import "Benchmarking/Scss/Footer.scss";
const Footer = () => {
  return (
    <div className="footer">
      <div className="content-footer">
        <p className="text">Explore</p>
        <p className="text">Benchmarking</p>
        <p className="text">Collaboration</p>
        <p className="text">Public profile</p>
      </div>
      <div className="content-footer">
        <p className="text">About Us</p>
        <p className="text">Feedback</p>
        <p className="text">Community</p>
      </div>
      <div className="content-footer">
        <p className="text">Resources</p>
        <p className="text">Term of Service</p>
        <p className="text">Privacy Policy</p>
        <p className="text">Help & Support</p>
      </div>
    </div>
  );
};

export default Footer;
